var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text != null)?_c('p',{class:_vm.color_text + '--text ' + _vm.text_type + (_vm.justify ? ' justified-text' : ''),attrs:{"slot":"text"},domProps:{"innerHTML":_vm._s(_vm.text)},slot:"text"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }